var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.22rem",
    height: "2.22rem",
    viewBox: "0 0 40 40",
    alt: "Add Item Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Click to add this item") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.39.74a18.5,18.5,0,1,0,18.5,18.5A18.52,18.52,0,0,0,20.39.74Zm0,34.6a16.1,16.1,0,1,1,16.1-16.1A16.09,16.09,0,0,1,20.39,35.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.69,18h-6.1v-6.1a1.2,1.2,0,0,0-2.4,0V18h-6.1a1.2,1.2,0,0,0,0,2.4h6.1v6.1a1.2,1.2,0,0,0,2.4,0v-6.1h6.1a1.2,1.2,0,0,0,0-2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/CirclePlus.77849eae.svg";
export { ForwardRef as ReactComponent };